export default __webpack_public_path__ + "static/aikido20-7b1e382d1c325edc08eb5ae2631a6198.jpg";